<template>
    <div>
        <div class="overlay_loading" v-if="!isLoaded">
            <div class="center_loading">
                <span>
                    <spinner text-fg-color="#ffffff" size="medium" message="Carregando sistema..."></spinner>
                </span>
            </div>
        </div>
        <div v-if="isLoaded">
            <div class="content-body" >
                <div class="row match-height">
                    <!-- Modal Component -->

                    <div v-bind:class="{ fullscreen_expand: isFullscreenUltimosCtes, 'col-xl-6 col-lg-6': !isFullscreenUltimosCtes }">
                    <div class="card" style="">

                        <div class="card-header">
                            <h4 class="card-title">Ultimos CTEs</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a v-b-tooltip title="Exemplo de botão"><i class="fa fa-exclamation-triangle"></i></a></li>
                                    <li><a @click="onFilterResetUltimosCtes()" v-b-tooltip title="Atualizar listagem"><i class="ft-rotate-cw"></i></a></li>
                                    <li><a @click="expandFullscreenUltimosCtes()" v-b-tooltip title="Expande a tela" v-if="!isFullscreenUltimosCtes"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreenUltimosCtes()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreenUltimosCtes"><i class="ft-minimize"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content" v-if="getPermissionFw('dashboard.ultimosctes')">
                            <div class="table-responsive">
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingDataUltimosCtes">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingDataUltimosCtes" text-fg-color="#ffffff" message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                    <vuetable ref="vuetable_ultimosctes"
                                            api-url="/api/dashboard/ultimosctes"
                                            :fields="fieldsUltimosCtes"
                                            :css="css"
                                            :append-params="moreParams"
                                            track-by="doc_id"
                                            pagination-path=""
                                            @vuetable:load-error="onError"
                                            @vuetable:pagination-data="onPaginationDataUltimosCtes"
                                            @vuetable:loaded="onLoadedUltimosCtes"
                                          >
                                          <template slot="status" slot-scope="props">
                                              <span class="badge badge-danger" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                              <span class="badge badge-warning" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                              <span class="badge badge-info" v-if="props.rowData.status.valor==3">{{ props.rowData.status.descr }}</span>
                                              <span class="badge badge-success" v-if="props.rowData.status.valor==4">{{ props.rowData.status.descr }}</span>
                                              <span class="badge badge-success" v-if="props.rowData.status.valor==6">{{ props.rowData.status.descr }}</span>
                                              <span class="badge badge-success" v-if="props.rowData.status.valor==8">{{ props.rowData.status.descr }}</span>
                                              <span class="badge badge-info" v-if="props.rowData.status.valor==5">{{ props.rowData.status.descr }}</span>
                                              <span class="badge badge-info" v-if="props.rowData.status.valor==7">{{ props.rowData.status.descr }}</span>
                                            </template>
                                          <template slot="status_sefaz" slot-scope="props">
                                              <span class="badge badge-warning" v-if="props.rowData.doc_cte.status_sefaz.valor==1">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                              <span class="badge badge-secondary" v-if="props.rowData.doc_cte.status_sefaz.valor==2">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                              <span class="badge badge-warning" v-if="props.rowData.doc_cte.status_sefaz.valor==3">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                              <span class="badge badge-success" v-if="props.rowData.doc_cte.status_sefaz.valor==4">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                              <span class="badge badge-danger" v-if="props.rowData.doc_cte.status_sefaz.valor==5">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                              <span class="badge badge-danger" v-if="props.rowData.doc_cte.status_sefaz.valor==6">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                              <span class="badge badge-danger" v-if="props.rowData.doc_cte.status_sefaz.valor==7">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                              <span class="badge badge-danger" v-if="props.rowData.doc_cte.status_sefaz.valor==9">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                              <span class="badge badge-info" v-if="props.rowData.doc_cte.status_sefaz.valor==8">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                            </template>

                                            <template slot="actions" slot-scope="props">
                                              <div class="custom-actions">
                                                <span v-if="getPermissionFw('cte.imprimir')">
                                                    <span v-if="props.rowData.doc_cte.status_sefaz.valor==4">
                                                        <a @click="onImprimirXml(props.rowData.doc_id, 1)" v-if="props.rowData.doc_cte.doc_cte_xml.length>0" v-b-tooltip title="Imprimir Dacte"><i class="fa fa-download"></i></a>
                                                    </span>
                                                </span>

                                                <span v-if="getPermissionFw('cte.imprimir')">
                                                    <span v-if="props.rowData.doc_cte.status_sefaz.valor==4">
                                                        <a @click="onDownloadXml(props.rowData.doc_cte.doccte_id)" v-if="props.rowData.doc_cte.doc_cte_xml.length>0" v-b-tooltip title="Download XML"><i class="fa fa-code"></i></a>
                                                    </span>
                                                </span>
                                            </div>
                                          </template>

                                      </vuetable>
                                  </div>
                                  <div class='col-md-12'>
                                      <div class="pull-left pagination-detail">
                                          <vuetable-pagination-info ref="paginationInfoUltimosCtes"
                                                                    :css="css.pagination"
                                                                    info-class="pull-left"
                                          ></vuetable-pagination-info>
                                      </div>
                                      <div class="pull-right m-a-0">
                                          <vuetable-pagination ref="paginationUltimosCtes"
                                                               :css="css.pagination"
                                                               @vuetable-pagination:change-page="onChangePageUltimosCtes"
                                          ></vuetable-pagination>
                                      </div>
                                  </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-bind:class="{ fullscreen_expand: isFullscreen, 'col-xl-6 col-lg-6 col-md-6 col-sm-6': !isFullscreen }" v-if="getPermissionFw('dashboard.graficos')">
                    <div class="card" style="">
                        <div class="card-header">
                            <h4 class="card-title">Faturamento por Tomador</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                    <table class="table table-striped">
                                      <thead>
                                        <tr>
                                          <th slot-scope="col">Tomador</th>
                                          <th slot-scope="col">Total</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="item in data_vlr_tomador">
                                          <td>{{ item.nome }}</td>
                                          <td>{{ formatNumber(item.total) }}</td>
                                        </tr>
                                        <tr>
                                          <td>Total</td>
                                          <td>{{formatNumber(total_tomadores)}}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                 </div>
                            </div>
                            <div class="table-responsive">
                                <div class="container">
                                    <pie-chart v-if="loadedChart" :datachart="datacollection"></pie-chart>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-bind:class="{ fullscreen_expand: isFullscreen, 'col-xl-12 col-lg-12': !isFullscreen }" v-if="getPermissionFw('dashboard.graficos')">
                    <div class="card" style="">
                        <div class="card-header">
                            <h4 class="card-title">Qtde. CTEs nos ultimos 15 meses</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div class="container">
                                    <line-chart v-if="loadedChart" :datachart="datacollectionQtdeCtes"></line-chart>
                                </div>
                            </div>
                            <div class="table-responsive">
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                    <table class="table table-striped">
                                      <thead>
                                        <tr>
                                          <th slot-scope="col">Data</th>
                                          <th slot-scope="col">Qtde.</th>
                                          <th slot-scope="col">Valor Total</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="item in data_qtde_ctes">
                                          <td>{{item.mes_ano}}</td>
                                          <td><span class="badge badge-primary">{{ item.total }}</span></td>
                                          <td>{{ formatNumber(item.vlr_total) }}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                 </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import VueClipboard from 'vue-clipboard2'
import ToggleButton from 'vue-js-toggle-button'
import accounting from 'accounting'
import moment from 'moment'
import vueDropzone from 'vue2-dropzone'
import VueCharts from 'vue-chartjs'
import LineChart from '../components/chart/LineChart'
import PieChart from '../components/chart/PieChart'

Vue.use(VueClipboard)
Vue.use(ToggleButton)

export default {
  components: {
      vueDropzone,
      LineChart,
      PieChart,
      VuetablePagination,
      VuetablePaginationInfo,
      Vuetable
  },
  data () {
      return {
        modal_titulo: '',
        modal_botao: '',
        modal_acao: '',
        datacollectionQtdeCtes: null,
        datacollection: null,
        showPopover: false,
        loading: false,
        loadedChart: false,
        disabled: false,
        isDisabled: false,
        loadingData: true,
        loadingDataUltimosCtes: true,
        showModal: false,
        isFullscreen: false,
        isFullscreenUltimosCtes: false,
        showModalPermission: false,
        showModalCadastroInicial: false,
        isFullscreenDashboard: false,
        optionsMunicipio: [],
        optionsParamTpDoc: [],
        isLoadingPeju: false,
        isLoadingPefi: false,
        total_tomadores: 0,
        unidade_documento: [],
        data_qtde_ctes: [],
        data_ultimos_ctes: [],
        data_vlr_tomador: [],
        formimprimir: new Form({
            doc_id: '',
            doc_id_pdf: [],
            doccte_id: '',
            tp_print: ''
        }),
        helpForm: new Form({params: [], search: ''}),
        fieldsUltimosCtes: [
          {
            name: 'num_fiscal',
            title: 'N° Fiscal',
            sortField: 'num_fiscal'
          },
          {
            name: 'serie',
            title: 'Série',
            sortField: 'serie'
          },
          {
            name: 'dt_emi',
            title: 'Data de emissão',
            callback: 'formatDate|DD/MM/YYYY HH:mm'
          },
          {
              name: '__slot:status',
              title: 'Status Doc'
          },
          {
              name: '__slot:status_sefaz',
              title: 'Status Sefaz'
          },
          {
              name: '__slot:actions',
              title: 'Ações',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
          }
        ],
        css: {
            loadingClass: 'loading',
            ascendingIcon: 'glyphicon glyphicon-chevron-up',
            descendingIcon: 'glyphicon glyphicon-chevron-down',
            handleIcon: 'glyphicon glyphicon-menu-hamburger',
        },
        moreParams: {},
        errors_array: [],
       }
    },
    mounted() {
        // this.getData();
    },
    methods: {
        expandFullscreenDashboard() {
            this.isFullscreenDashboard = !this.isFullscreenDashboard;
        },
        expandFullscreenUltimosCtes() {
            this.isFullscreenUltimosCtes = !this.isFullscreenUltimosCtes;
        },
        onPaginationDataUltimosCtes (paginationData) {
          this.$refs.paginationUltimosCtes.setPaginationData(paginationData)
          this.$refs.paginationInfoUltimosCtes.setPaginationData(paginationData)
        },
        onChangePageUltimosCtes (page) {
          this.$refs.vuetable_ultimosctes.changePage(page)
        },
        onChangeStatusBFiscal(e) {
            this.form_integracao.status_integracao_bfiscal = e.value;
        },
        onChangeStatusCancelamento(e) {
            this.helpForm.status_canc_exp_erp  = e.value;
        },
        onChangeStatusCancelamentoFatura(e) {
            this.helpForm.status_canc_cte_com_fatura  = e.value;
        },
        onLoadedUltimosCtes: function () {
            this.dataExport = this.$refs.vuetable_ultimosctes.tableData;
            this.loadingDataUltimosCtes = false;
        },
        onFilterResetUltimosCtes () {
            this.loadingDataUltimosCtes = true;
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable_ultimosctes.refresh())
        },
        DateFormat: function(date) {
          if(date != null){
          return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
          }
          return "";
        },
        disableByRef () {
            this.disabled = true;
        },
        formatNumber (value) {
            return accounting.formatNumber(value, 2, '.', ',')
        },
        getDataGraficos()
        {
            this.loading = true;
            this.isDisabled = true;
            this.helpForm.get('/api/dashboard/chart').then(response =>
            {
                this.data_qtde_ctes = response.qtde_ctes;
                this.data_ultimos_ctes = response.ultimos_ctes;
                this.data_vlr_tomador = response.vlr_tomador;

                // Vlr tomador
                if(response.vlr_tomador!==null)
                {
                    this.total_tomadores = 0;
                    response.vlr_tomador.forEach((obj)=>{
                        this.total_tomadores = this.total_tomadores+parseFloat( obj.total);
                    });

                    var va_labels = [];
                    var va_dataset = [];
                    this.data_vlr_tomador.forEach((obj)=>{
                        va_labels.push(obj.nome);
                        va_dataset.push(obj.total);
                    });

                    this.datacollection = {
                      //Data to be represented on x-axis
                      labels: va_labels,
                      datasets: [
                        {
                          label: '% Por valor',
                          backgroundColor: ['#f58742', '#f5e042', '#adf542', '#78f542', '#42f54b', '#42f5a4', '#42eff5', '#42a7f5', '#4272f5', '#5d42f5', '#00a8ff', '#16d39a', '#ffa87d', '#fca103', '#fc8003', '#fc6203', '#fc3503', 'fc1403', 'fc0303', '#f54242' ] ,
                          pointBackgroundColor: 'white',
                          borderWidth: 1,
                          pointBorderColor: '#249EBF',
                          data: va_dataset
                        }
                      ]
                    }
                }

                // qtde_ctes
                if(response.qtde_ctes!==null)
                {
                    var va_labels = [];
                    var va_dataset = [];
                    var va_dataset_cte = [];
                    this.data_qtde_ctes.forEach((obj)=>{
                        va_labels.push(obj.mes_ano);
                        va_dataset.push(obj.total);
                        va_dataset_cte.push(obj.vlr_total);
                    });
                    this.datacollectionQtdeCtes = {
                      //Data to be represented on x-axis
                      labels: va_labels,
                      datasets: [
                          {
                            label: 'Valor',
                            backgroundColor: '#249EBF' ,
                            pointBackgroundColor: 'white',
                            borderWidth: 1,
                            pointBorderColor: '#249EBF',
                            data: va_dataset_cte
                        },
                        {
                          label: 'CTEs gerados por mês',
                          backgroundColor: '#076bad' ,
                          pointBackgroundColor: 'white',
                          borderWidth: 1,
                          pointBorderColor: '#249EBF',
                          data: va_dataset
                      }
                   ],
                    }
                }
                this.loadedChart = true;
                this.loadingData = false;
            })
            .catch(errors =>
            {
                this.loadedChart = true;
                this.loadingData = false;
            });
        },
        getData() {
            this.helpForm.get('/api/dashboard/dados').then(response =>
            {
                this.getDataGraficos();
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        formatDate(value, fmt = 'DD/MM/YYYY HH:mm') {
            return (value == null) ?
                '' :
                moment(value, 'YYYY-MM-DD HH:mm').format(fmt)
        },
        onError(response) {
            new ReturnApi(response.response, this, true, true, false);
        },
        onReloadResponse(response) {
            new ReturnApi(response, this);
        },
        limitText (count) {
          return ' e ${count} outros clientes'
        },
        onImprimirXml(doc_id, tp_print) {
            this.loading = true;
            this.isDisabled = true;
            this.formimprimir.doc_id_pdf = [];
            if (tp_print == 2 || tp_print == 3) {
                this.$refs.vuetable.selectedTo.forEach((obj) => {
                    this.formimprimir.doc_id_pdf.push({
                        id: obj
                    })
                });
            } else if (tp_print == 1) {
                this.formimprimir.doc_id_pdf.push({
                    id: doc_id
                })
            }
            this.formimprimir.tp_print = tp_print;

            this.loading = true;
            this.isDisabled = true;
            this.formimprimir.post('/api/cte/imprimircte').then(response => {
              new ReturnApi(response, this)
            })
            .catch(errors => {
              new ReturnApi(errors, this)
            });
        },
        onDownloadXml(doccte_id) {
            this.loading = true;
            this.isDisabled = true;
            this.formimprimir.doccte_id = doccte_id;
            this.formimprimir.post('/api/cte/downloadxml').then(response => {
                    new ReturnApi(response, this)
                })
                .catch(errors => {
                    new ReturnApi(errors, this)
                });
        },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito)
        {
            var cnpj_formatado
            var pad = "00000000"
            var cnpj_base = pad.substring(0, pad.length - cnpj_base.length) + cnpj_base;
            var pad = "0000"
            var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.length) + cnpj_filial;
            var pad = "00"
            var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.length) + cnpj_digito;

            return cnpj_base+""+cnpj_filial+""+cnpj_digito;
        },
        getLivGeral() {
            this.helpForm.get('/api/dashboard/jsonlist').then(response =>
            {
                new ReturnApi(response, this, true, false, false);
                response.municipio.forEach((obj)=>
                {
                    this.optionsMunicipio.push({ label: obj.nome, value: obj.municipio_id })
                })

                response.param_tp_doc.forEach((obj)=>
                {
                    this.optionsParamTpDoc.push({ label: obj.descr, value: obj.partipdoc_id })
                })
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
    },
    computed: {
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        },
        multi_empresa: {
            get() {
                return this.$store.getters.multi_empresa;
            }
        },
        introducao: {
            get() {
                return this.$store.getters.introducao;
            }
        },
        cadastro_inicial: {
            get() {
                return this.$store.getters.cadastro_inicial;
            }
        }
    }
}
</script>
